var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticClass:"map-img",attrs:{"src":require("../../../public/image/internet_conference_build_a.png")},on:{"click":function($event){return _vm.getImg(0)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }